// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6ec95cc2","404":"c72d8008","787":"16f520d6"}[chunkId] + ".chunk.js";
};